/** Whether the invitation link should use redeem/reset (profile password gate) vs set-password on token page. */
export function shouldUsePasswordResetFlow(profileType: string | undefined, passwordSetByUser: boolean): boolean {
    if (passwordSetByUser) {
        return true;
    }
    // Athletes with a temporary password should set a new one on their profile (same as admin/staff
    // redeem flow), not on the token page — otherwise they land on Home and miss the password gate.
    return (profileType || '').toUpperCase() === 'ATHLETE';
}

export function resolvePasswordResetPath(profileType?: string | null): string {
    if (profileType === 'ATHLETE') {
        return '/athlete/profile';
    }
    return '/add-admin-profile';
}
